import { createApp } from 'vue';
import * as echarts from 'echarts';
import App from './App.vue';
// 安装全局 echarts resize 管理器（会挂到 window.__chartResize 供 jQuery 老脚本使用）
import './utils/chartResize';
// 让 public/assets/js 下的 jQuery 老脚本（js.js、area_echarts.js 等）共用同一份 echarts
window.echarts = echarts;
console.log('APP_CONFIG:', window.APP_CONFIG);
const app = createApp(App);
app.mount('#app');
